import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ApiService } from '../../services/api.service';
import Swal from 'sweetalert2';

@Component({
	selector: 'ngx-app-registration',
	templateUrl:'./register.component.html',
	styleUrls: ['./register.component.css']
  })
  export class RegisterComponent  implements OnInit {

	_registerForm: FormGroup;
	_step: number = 0;

	clicked: boolean = false;
	baseUrl: string = 'account';
	@Input()
	public firstName: string;
	@Input()
	public lastName: string;
	@Input()
	public emailAddr: string;
	@Input()
	public contactNo: string;

	constructor( private apiService: ApiService, private router: Router){
		this._registerForm = new FormGroup({
			Email: new FormControl(null, [Validators.required, Validators.email]),
		  });
	};
	ngOnInit(){
		return;
	}

	get form() {
		return this._registerForm;
	  }


	register(){
		return new Promise((resolve) => {
		  let redirectUrl = window.location.origin;
		  let payload = { Email: this.form.controls['Email'].value, RoleId: 1, RedirectUrl : redirectUrl };
		  this.apiService.post(`${this.baseUrl}/register`, payload)
		  .subscribe((response: any) => {
			resolve(response);
			console.log(response)
			this.onRegistrationComplete()
		  },(error:any)=>{

		  });

		});
	  }

	  onRegistrationComplete(){
		Swal.fire({
			title: 'Registration Completed',
			html: 'A <b>temporary password</b> has been sent to your email(<b>'+ this.form.controls['Email'].value +'</b>).<br><br> Please check your inbox and use the temporary password to log in.' ,
			showCancelButton: true,
			confirmButtonText: 'Proceed to Login',
			cancelButtonText: 'Cancel'
		  }).then((result) => {
			if (result.isConfirmed) {
				this.router.navigate(["/auth/login"]);
			} else if (result.dismiss === Swal.DismissReason.cancel) {
			  return false;
			}
		  });
	  }

	  backToLogin(){
		this.router.navigate(["/auth/login"]);
	  }


  }